export {Anchor} from 'antd';
export type {AnchorLinkProps, AnchorProps} from 'antd/es/anchor/index';
